"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// @index('./*', pp => `export * from '${pp.path}';`)
__export(require("./ExtendedPropertyType"));
//# sourceMappingURL=index.js.map